.content {
  box-sizing: border-box;
  cursor: pointer;

  @media (prefers-reduced-motion: no-preference) {
    transition:
      border-color var(--dds-motion-micro-state),
      background-color var(--dds-motion-micro-state),
      var(--dds-focus-transition);
  }

  &:hover {
    border-color: var(--dds-color-border-action-hover);
    background-color: var(--dds-color-surface-hover-default);
  }
}

input:checked + .content {
  color: var(--dds-color-text-on-action);
  background-color: var(--dds-color-surface-action-resting);
  border-color: var(--dds-color-surface-action-resting);
}

input:checked + .content:hover {
  background-color: var(--dds-color-surface-action-hover);
  border-color: var(--dds-color-surface-action-hover);
}
